import { useState, useEffect, Fragment } from 'react'
import Modal from 'react-modal'
import parse from 'html-react-parser'
import useWindowDimensions from '@hooks/useWindowDimensions.js'

Modal.setAppElement('*') // suppresses modal-related test warnings.

import { embroideryData } from '../../data/embroidery_data.js'

import { slugify, getHexClass } from '@utils/utils.js'

import embroideryDefaultImage from '../../assets/images/embroidery-default.png'

import './Embroidery.scss'

const Embroidery = ({
    addEmbroidery,
    setAddEmbroidery,
    productOptions,
    handleOptions,
    setProductOptions,
    clearOptions,
    productHandle,
    handleAddToCart,
    currentSize,
}) => {
    const [modalIsOpen, setIsOpen] = useState(false)
    const [saving, setSaving] = useState(false)
    const [width, setWidth] = useState()
    const [type, setType] = useState('')
    const { windowWidth, windowHeight } = useWindowDimensions()

    let hasMama = false

    const breakpoint = 900

    const openModal = () => {
        if (modalIsOpen) {
            closeModal()
            return
        }
        setIsOpen(true)
    }

    const closeModal = (e) => {
        if (
            e &&
            e.target.getAttribute('data-option') &&
            e.target.getAttribute('data-option') === 'embroiderySubmitted'
        ) {
            setSaving(true)
            setTimeout(() => {
                setIsOpen(false)
                setSaving(false)
            }, 3000)
            return
        }
        setIsOpen(false)
    }

    useEffect(() => {
        setWidth(window.innerWidth)
        window.addEventListener('resize', () => setWidth(window.innerWidth))
    }, [])

    const data = embroideryData.embroidery

    //

    //

    const embroideryProducts = data.products

    const embroideryThreadColors = data.threads
    let threadColors = embroideryThreadColors

    // console.log ('embroideryThreadColors', embroideryThreadColors)

    let embroideryProduct = embroideryProducts.filter((p) => {
        return p.productHandle === productHandle
    })

    const embroideryFonts = data.fonts

    const productFonts = embroideryProduct[0].fonts

    //

    const embroideryTypes = embroideryProduct[0].embroideryTypes

    //

    if (
        embroideryTypes &&
        embroideryTypes.length > 0 &&
        embroideryTypes.includes('Mama')
    ) {
        hasMama = true
    }

    const onTypeChange = (e) => {
        setType(e.target.value)
    }

    let filteredFonts = embroideryFonts.filter(function (e) {
        return (
            productFonts.filter(function (p) {
                return p.active === true && p.webName === e.webName
            }).length > 0
        )
    })

    //

    if (productOptions.embroideryType === 'Mama') {
        filteredFonts = filteredFonts.filter((f) => {
            return f.displayName === 'Mama'
        })
    }

    let monogramTextArray = []
    let monogramText

    if (
        productOptions.embroideryFont &&
        productOptions.embroideryFont.webName === 'Monogram'
    ) {
        monogramTextArray = [...productOptions.embroideryText]

        //

        monogramText = monogramTextArray
            .map((t, i) => {
                if (i === 0) {
                    return '<span className="monogram-left">' + t + '</span>'
                } else if (i === 1) {
                    return '<span className="monogram-center">' + t + '</span>'
                } else if (i === 2) {
                    return '<span className="monogram-right">' + t + '</span>'
                }
            })
            .join('')

        //
    }

    if (productOptions.embroideryType === 'Monogram') {
        filteredFonts = filteredFonts.filter((f) => {
            return f.displayName !== 'Mama'
        })
    }

    // console.log ('embroideryProduct', embroideryProduct)

    // const colors = embroideryProduct[0].colors

    let characterLimit

    if (productOptions.embroideryCharacterLimit) {
        characterLimit = productOptions.embroideryCharacterLimit
    } else if (
        productOptions.embrroideryType &&
        productOptions.embrroideryType === 'Mama'
    ) {
        characterLimit = 4
    } else {
        characterLimit = 20
    }

    let twoLines = false

    if (
        embroideryProduct &&
        embroideryProduct[0] &&
        embroideryProduct[0].twoLines
    ) {
        twoLines = true
    }

    //

    const verifyProductOptions = (productOptions) => {
        const options = productOptions
        return (
            options &&
            options.embroideryColor.threadColor &&
            options.embroideryColor.name &&
            options.embroideryFont.webName &&
            options.embroideryFont.fontName &&
            options.embroideryText
        )
    }

    let verified = verifyProductOptions(productOptions)

    //

    let currentTextColorClass = 'text-ash'
    let currentBgColorClass = 'bg-[#f2f2f2]'

    if (
        productOptions &&
        productOptions.embroideryColor &&
        productOptions.embroideryColor.hex
    ) {
        if (productOptions.embroideryColor.hex === '#F6B7D2') {
            currentTextColorClass = `text-[#F6B7D2]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#F69679') {
            currentTextColorClass = `text-[#F69679]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#F9A980') {
            currentTextColorClass = `text-[#F9A980]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#FFE293') {
            currentTextColorClass = `text-[#FFE293]`
            currentBgColorClass = 'bg-[#999999]'
        } else if (productOptions.embroideryColor.hex === '#C19846') {
            currentTextColorClass = `text-[#C19846]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#B7403D') {
            currentTextColorClass = `text-[#B7403D]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#EA7542') {
            currentTextColorClass = `text-[#EA7542]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#FFE6CB') {
            currentTextColorClass = `text-[#FFE6CB]`
            currentBgColorClass = 'bg-[#999999]'
        } else if (productOptions.embroideryColor.hex === '#FFFFFF') {
            currentTextColorClass = `text-[#FFFFFF]`
            currentBgColorClass = 'bg-[#999999]'
        } else if (productOptions.embroideryColor.hex === '#414042') {
            currentTextColorClass = `text-[#414042]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#67C18C') {
            currentTextColorClass = `text-[#67C18C]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#94BDE5') {
            currentTextColorClass = `text-[#94BDE5]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#455287') {
            currentTextColorClass = `text-[#455287]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#A7A0CB') {
            currentTextColorClass = `text-[#A7A0CB]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#E6E7E8') {
            currentTextColorClass = `text-[#E6E7E8]`
            currentBgColorClass = 'bg-[#999999]'
        } else if (productOptions.embroideryColor.hex === '#FCA4DC') {
            currentTextColorClass = `text-[#FCA4DC]`
            currentBgColorClass = 'bg-[#f2f2f2]'
        } else if (productOptions.embroideryColor.hex === '#FCED7E') {
            currentTextColorClass = `text-[#FCED7E]`
            currentBgColorClass = 'bg-[#999999]'
        } else if (productOptions.embroideryColor.hex === '#89E889') {
            currentTextColorClass = `text-[#89E889]`
            currentBgColorClass = 'bg-[#999999]'
        } else if (productOptions.embroideryColor.hex === '#FFAC48') {
            currentTextColorClass = `text-[#FFAC48]`
            currentBgColorClass = 'bg-[#999999]'
        } else {
            currentTextColorClass = `text-ash`
        }
    }

    let currentFontClass = 'Cursive'

    if (
        productOptions &&
        productOptions.embroideryFont &&
        productOptions.embroideryFont.webName
    ) {
        const name = productOptions.embroideryFont.webName

        //
        if (name === 'Monogram') {
            currentFontClass = 'font-[Monogram]'
        } else if (name === 'Cursive') {
            currentFontClass = 'font-[Castledown]'
        } else if (name === 'Handwriting') {
            currentFontClass = 'font-[Handwriting]'
        } else if (
            name === 'School' ||
            name === 'Learning Curve' ||
            name === 'School House'
        ) {
            currentFontClass = 'font-[Script]'
        } else if (name === 'Serif') {
            currentFontClass = 'value-serif'
        } else if (name === 'Sans Serif') {
            currentFontClass = 'font-[Styrene B Web]'
        } else if (name === 'Athletic') {
            currentFontClass = 'font-[Athletic]'
        } else if (name === 'Calligraphy') {
            currentFontClass = 'font-[Calligraphy]'
        } else if (name === 'Typewriter') {
            currentFontClass = 'font-[Typewriter]'
        } else if (name === 'Mama') {
            currentFontClass = 'font-[Calligraphy]'
        }
    }

    //

    return (
        <div
            id="pdp-embroidery"
            className={`embroidery-outer pt-6 ${
                productOptions.embroidery ? 'embroidery-open' : ''
            }`}
        >
            <div className="embroidery-inner">
                <div className="embroidery-heading mb-3">
                    <h3 className="">Personalize It</h3>
                </div>
                <div className="embroidery-options">
                    <div className="embroidery-option add-embroidery p-4 bg-sun/50 w-full">
                        {!currentSize.size ? (
                            <p className="block mobile-size-error text-xs mb-0 text-gray-500 w-full">
                                Please select a size before choosing embroidery
                                options.
                            </p>
                        ) : null}
                        <label htmlFor="addEmbroidery flex items-center w-full">
                            <div className="flex items-center w-full flex-wrap lg:flex-nowrap">
                                <input
                                    className={`${
                                        !currentSize.size
                                            ? 'disabled noclick opacity-80 cursor-not-allowed'
                                            : 'opacity-100'
                                    }`}
                                    checked={productOptions.embroidery}
                                    type="checkbox"
                                    id="addEmbroidery"
                                    name="addEmbroidery"
                                    aria-label={
                                        productOptions.embroidery
                                            ? 'Uncheck to Remove Embroidery'
                                            : null
                                    }
                                    disabled={!currentSize.size}
                                    data-balloon-pos="up-left"
                                    onChange={(e) =>
                                        handleOptions(e, {
                                            embroidery:
                                                !productOptions.embroidery,
                                        })
                                    }
                                    onClick={
                                        !productOptions.embroidery
                                            ? openModal
                                            : null
                                    }
                                />{' '}
                                &nbsp;&nbsp;
                                {productOptions.embroidery
                                    ? 'Embroidery Added'
                                    : 'Add Embroidery'}
                                &nbsp;
                                {productOptions.embroidery ? (
                                    <Fragment>
                                        <span
                                            className={`lg:ml-4 embroidery-edit font-normal text-xs bg-oat hover:bg-flint px-3 py-2 hover:text-white rounded-lg cursor-pointer ml-auto ${
                                                !currentSize.size
                                                    ? 'disabled noclick opacity-80'
                                                    : 'opacity-100'
                                            }`}
                                            data-balloon-pos="up"
                                            aria-label={
                                                !currentSize.size
                                                    ? 'Please select a size'
                                                    : null
                                            }
                                            data-option="view-edit"
                                            onClick={(e) => {
                                                openModal()
                                                handleOptions(e, 'view-edit')
                                            }}
                                        >
                                            View/Edit Options
                                        </span>
                                        <span
                                            className={`ml-4 embroidery-verified text-xs font-normal mt-2 lg:mt-0 ${
                                                productOptions.embroideryVerified
                                                    ? 'text-green-600'
                                                    : 'text-red-600'
                                            }`}
                                        >
                                            {productOptions.embroideryVerified &&
                                            productOptions.embroideryVerified ===
                                                true ? (
                                                <span>
                                                    ✓&nbsp;All options selected
                                                </span>
                                            ) : (
                                                <span>
                                                    ✗&nbsp;Please select all
                                                    required options
                                                </span>
                                            )}
                                        </span>
                                    </Fragment>
                                ) : null}
                                {/* IMPORTANT: Do not remove this comment out code. Commenting this out for Flip_2025-03-27 */}
                                <span className="embroidery-price ml-auto font-normal mt-2 lg:mt-0">
                                    $15.00
                                </span>
                                {/* <span className="embroidery-price ml-auto font-normal mt-2 lg:mt-0">
                                    Free!
                                </span> */}
                            </div>
                        </label>
                    </div>
                    {productOptions.embroidery ? (
                        <p className="text-xs text-flint my-2 font-normal">
                            <span className="font-bold">Important note:</span>{' '}
                            once you have selected your personalized options,
                            please add the item to your cart before leaving this
                            page otherwise your options will be cleared.
                        </p>
                    ) : null}
                    {productOptions.embroidery ? (
                        <Modal
                            isOpen={modalIsOpen}
                            onRequestClose={closeModal}
                            className="embroidery-modal"
                        >
                            <div className="embroidery-modal-outer p-6 lg:p-12 relative h-[90vh] overflow-y-auto z-[999]">
                                <div className="modal-close flex items-center">
                                    <span
                                        className="close-modal absolute -top-2 right-3 cursor-pointer text-[36px] font-normal text-[#B8B9BA] hover:text-ash"
                                        onClick={closeModal}
                                    >
                                        &times;
                                    </span>
                                </div>
                                <div className="embroidery-modal-inner flex lg:gap-12 flex-wrap lg:flex-nowrap max-w-[100vw] lg:max-w-[1000px]">
                                    <div className="options-outer lg:w-1/2 w-full">
                                        <div className="options-inner flex flex-col">
                                            <div className="embroidery-option embroidery-type">
                                                <h2 className="text-2xl mb-2">
                                                    Personalize It
                                                </h2>
                                            </div>

                                            <Fragment>
                                                {hasMama ? (
                                                    <div className="embroidery-option embroidery-type">
                                                        <h3 className="option-heading text-base">
                                                            Embroidery Text
                                                            Type*{' '}
                                                            <span className="text-xs font-normal">
                                                                (required)
                                                            </span>
                                                        </h3>
                                                        <div className="embroidery-type-select">
                                                            <ul className="type-options flex items-center gap-5 mt-2 my-4">
                                                                <li>
                                                                    <input
                                                                        className="mr-1 relative top-[1px]"
                                                                        type="radio"
                                                                        id="Mama"
                                                                        name="Mama"
                                                                        value="Mama"
                                                                        checked={
                                                                            productOptions.embroideryType ===
                                                                            'Mama'
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handleOptions(
                                                                                e,
                                                                                'type'
                                                                            )
                                                                        }
                                                                    />
                                                                    <label
                                                                        htmlFor="Mama"
                                                                        className="text-sm font-normal"
                                                                    >
                                                                        Mama
                                                                    </label>
                                                                </li>
                                                                <li>
                                                                    <input
                                                                        className={`mr-1 relative top-[1px]`}
                                                                        type="radio"
                                                                        id="Monogram"
                                                                        name="Monogram"
                                                                        value="Monogram"
                                                                        checked={
                                                                            productOptions.embroideryType ===
                                                                            'Monogram'
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handleOptions(
                                                                                e,
                                                                                'type'
                                                                            )
                                                                        }
                                                                    />
                                                                    <label
                                                                        htmlFor="Monogram"
                                                                        className="text-sm font-normal"
                                                                    >
                                                                        Monogram
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                ) : null}

                                                <div
                                                    className={`embroidery-option embroidery-text-input`}
                                                >
                                                    <label
                                                        className="text-base"
                                                        htmlFor="embroideryText"
                                                    >
                                                        Embroidery Text*{' '}
                                                        <span>{`(max ${characterLimit} characters)`}</span>
                                                    </label>
                                                    <Fragment>
                                                        <input
                                                            className={`w-full p-3 bg-[#F0F1F1] ${
                                                                productOptions.embroideryError &&
                                                                productOptions
                                                                    .embroideryError
                                                                    .text
                                                                    ? 'border border-red-500'
                                                                    : ''
                                                            } ${
                                                                productOptions.embroideryType ===
                                                                'Monogram'
                                                                    ? 'uppercase'
                                                                    : ''
                                                            }`}
                                                            value={
                                                                productOptions.embroideryText
                                                            }
                                                            type="text"
                                                            id="embroideryText"
                                                            name="embroideryText"
                                                            autoCapitalize="none"
                                                            maxLength={
                                                                productOptions.embroideryCharacterLimit
                                                            }
                                                            onChange={(e) =>
                                                                handleOptions(e)
                                                            }
                                                        />
                                                        <div className="embroidery-info mt-1 mb-2">
                                                            <p
                                                                className={`text-xs font-normal block ${
                                                                    productOptions.embroideryVerified
                                                                        ? 'text-ash'
                                                                        : ''
                                                                }`}
                                                            >
                                                                {verified
                                                                    ? null
                                                                    : `${
                                                                          productOptions
                                                                              .embroideryText
                                                                              .length >
                                                                          0
                                                                              ? `${' '}`
                                                                              : 'Please enter desired text.'
                                                                      }`}
                                                            </p>
                                                            {productOptions.embroideryFont &&
                                                            productOptions
                                                                .embroideryFont
                                                                .displayName ===
                                                                'Monogram' ? (
                                                                <p className="text-xs font-normal block mt-1 mb-2">
                                                                    Monogram is
                                                                    limited to 3
                                                                    characters
                                                                    and letters
                                                                    only (A-Z) —
                                                                    no numbers
                                                                    or special
                                                                    characters.
                                                                </p>
                                                            ) : null}
                                                        </div>
                                                    </Fragment>
                                                </div>

                                                {/* {twoLines ? (
                                                    <div
                                                        className={`embroidery-option embroidery-text2-input`}
                                                    >
                                                        <label
                                                            className="text-xs font-normal"
                                                            htmlFor="embroideryText2"
                                                        >
                                                            Embroidery Second
                                                            Line (optional){' '}
                                                            <span>{`(max ${characterLimit} characters)`}</span>
                                                        </label>

                                                        <input
                                                            className={`w-full p-3 bg-[#F0F1F1] ${
                                                                verified
                                                                    ? ' border-1 border-green-500'
                                                                    : ''
                                                            }`}
                                                            value={
                                                                productOptions.embroideryText2
                                                            }
                                                            type="text"
                                                            id="embroideryText2"
                                                            name="embroideryText2"
                                                            autoCapitalize="none"
                                                            maxLength={
                                                                characterLimit
                                                            }
                                                            onChange={(e) =>
                                                                handleOptions(e)
                                                            }
                                                        />
                                                    </div>
                                                ) : null} */}
                                            </Fragment>

                                            <div
                                                className={`embroidery-option embroidery-fonts my-4`}
                                            >
                                                <h3
                                                    className={`option-heading mt-4 ${
                                                        productOptions.embroideryError &&
                                                        productOptions
                                                            .embroideryError
                                                            .font
                                                            ? 'mb-0'
                                                            : 'mb-2'
                                                    }`}
                                                >
                                                    Font
                                                    {productOptions.embroideryFont &&
                                                    productOptions
                                                        .embroideryFont
                                                        .displayName
                                                        ? ': ' +
                                                          productOptions
                                                              .embroideryFont
                                                              .displayName
                                                        : ''}
                                                </h3>
                                                {productOptions.embroideryError &&
                                                productOptions.embroideryError
                                                    .font ? (
                                                    <p className="text-xs text-red-500 font-normal mb-2">
                                                        Please select a font.
                                                    </p>
                                                ) : null}

                                                <ul className="nostyle fonts-list grid grid-cols-6 gap-1 lg:gap-1">
                                                    {filteredFonts.map(
                                                        (f, i) => {
                                                            {
                                                                /*  */
                                                            }
                                                            return (
                                                                <li
                                                                    key={
                                                                        f.webName +
                                                                        '-' +
                                                                        productHandle +
                                                                        '-' +
                                                                        i
                                                                    }
                                                                    className={``}
                                                                >
                                                                    <div
                                                                        className={`font-image aspect-square border-oat ${
                                                                            productOptions.embroideryFont &&
                                                                            productOptions
                                                                                .embroideryFont
                                                                                .webName ===
                                                                                f.webName
                                                                                ? 'font-selected underline border-2 border-ocean text-ocean'
                                                                                : ''
                                                                        }`}
                                                                        aria-label={
                                                                            f.displayName
                                                                        }
                                                                        data-balloon-pos="up"
                                                                    >
                                                                        {f.fontImage ? (
                                                                            <img
                                                                                src={
                                                                                    f.fontImage
                                                                                }
                                                                                alt={
                                                                                    f.webName +
                                                                                    ' font sample'
                                                                                }
                                                                                data-option="embroideryFont"
                                                                                onClick={(
                                                                                    e
                                                                                ) =>
                                                                                    handleOptions(
                                                                                        e,
                                                                                        f
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <span
                                                                                className="font-normal"
                                                                                data-option="embroideryFont"
                                                                                onClick={(
                                                                                    e
                                                                                ) =>
                                                                                    handleOptions(
                                                                                        e,
                                                                                        f
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    f.displayName
                                                                                }
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                            <div className="embroidery-option embroidery-colors my-2 lg:my-4">
                                                <h3
                                                    className={`option-heading ${
                                                        productOptions.embroideryError &&
                                                        productOptions
                                                            .embroideryError
                                                            .color
                                                            ? 'mb-0'
                                                            : 'mb-2'
                                                    }`}
                                                >
                                                    Thread Color
                                                    <span className="font-normal">
                                                        {productOptions.embroideryColor &&
                                                        productOptions
                                                            .embroideryColor
                                                            .name
                                                            ? ': ' +
                                                              productOptions
                                                                  .embroideryColor
                                                                  .name
                                                            : ''}
                                                    </span>
                                                </h3>
                                                {productOptions.embroideryError &&
                                                productOptions.embroideryError
                                                    .color ? (
                                                    <p className="text-xs text-red-500 font-normal mb-2">
                                                        Please select a thread
                                                        color.
                                                    </p>
                                                ) : null}
                                                <ul className="nostyle colors-list grid grid-cols-6 items-center gap-1 lg:gap-2 flex-wrap">
                                                    {threadColors &&
                                                        threadColors.map(
                                                            (c) => {
                                                                //
                                                                return (
                                                                    <li
                                                                        key={
                                                                            c.hex
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={`color-image w-14 h-14 border-oat border rounded-full bg-${
                                                                                c.hex
                                                                            } ${
                                                                                productOptions.embroideryColor &&
                                                                                productOptions
                                                                                    .embroideryColor
                                                                                    .name ===
                                                                                    c.name
                                                                                    ? 'color-selected border-4 border-ocean'
                                                                                    : ''
                                                                            }`}
                                                                            style={{
                                                                                backgroundColor:
                                                                                    c.hex,
                                                                            }}
                                                                            aria-label={
                                                                                c.name
                                                                            }
                                                                            data-balloon-pos="up"
                                                                            onClick={(
                                                                                e
                                                                            ) =>
                                                                                handleOptions(
                                                                                    e,
                                                                                    c
                                                                                )
                                                                            }
                                                                            data-option="embroideryColor"
                                                                        ></div>
                                                                    </li>
                                                                )
                                                            }
                                                        )}
                                                </ul>
                                            </div>

                                            <div className="embroidery-option embroidery-price my-2 py-2 lg:my-4 lg:py-4">
                                                <h3 className="option-heading">
                                                    Options Additional Price:{' '}
                                                    {/* IMPORTANT: Do not remove this comment out code. Commenting this out for Flip_2025-03-27 */}
                                                    <span className="price">
                                                        +$15.00
                                                    </span>
                                                    {/* <span className="price">
                                                        Free!
                                                    </span> */}
                                                </h3>
                                            </div>

                                            <div className="product-add-to-cart w-full">
                                                <Fragment>
                                                    <input
                                                        type="hidden"
                                                        min="1"
                                                        name="quantity"
                                                        value="1"
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="id"
                                                        id="variant-id"
                                                        value={
                                                            currentSize.variantId
                                                                ? currentSize.variantId
                                                                : ''
                                                        }
                                                    />
                                                </Fragment>
                                                <button
                                                    type={
                                                        !currentSize.size
                                                            ? null
                                                            : 'submit'
                                                    }
                                                    className={`large-button button-atc w-full !h-[60px] ${
                                                        !currentSize.size
                                                            ? 'disabled noclick opacity-80'
                                                            : 'hover:bg-ash opacity-100'
                                                    }  ${
                                                        verified
                                                            ? ''
                                                            : 'noclick opacity-80'
                                                    }`}
                                                    // data-balloon-blunt
                                                    data-balloon-pos="up"
                                                    data-balloon-length="fit"
                                                    aria-label={
                                                        !currentSize.size
                                                            ? 'Please select a size'
                                                            : !verified
                                                            ? 'Please select all options.'
                                                            : null
                                                    }
                                                    disabled={
                                                        verified ? false : true
                                                    }
                                                    onClick={(e) =>
                                                        handleAddToCart(e)
                                                    }
                                                >
                                                    Add To Cart
                                                </button>
                                            </div>
                                            <div className="submit-options my-4 flex items-center gap-3 flex-wrap lg:flex-nowrap">
                                                <button
                                                    className={`btn button secondary-button large-button cancel-button bg-red-500 border border-red-500 h-[42px] hover:bg-red-700 text-white flex items-center justify-center px-2 rounded-md options-cancel-button text-xs`}
                                                    onClick={(e) => {
                                                        clearOptions(e)
                                                        closeModal()
                                                    }}
                                                    aria-label="This removes embroidery completely. Are you sure?"
                                                    data-balloon-pos="up"
                                                    data-balloon-length="fit"
                                                >
                                                    Remove Embroidery
                                                </button>
                                                <button
                                                    className={`btn button secondary-button large-button clear-button bg-slate border border-ash h-[42px] hover:bg-flint hover:text-white flex items-center justify-center px-2 rounded-md options-clear-button text-xs flex-1`}
                                                    onClick={(e) =>
                                                        clearOptions(e)
                                                    }
                                                    aria-label="All selected options will be cleared. Are you sure?"
                                                    data-balloon-pos="up"
                                                    data-balloon-length="fit"
                                                >
                                                    Clear Options
                                                </button>
                                                <button
                                                    className={`btn button primary-button large-button bg-flint border border-flint h-[42px] text-white hover:bg-coal flex items-center justify-center px-2 rounded-md text-xs min-w-full lg:min-w-[180px] lg:w-auto lg:max-w-[200px] ${
                                                        verified
                                                            ? ''
                                                            : 'disabled'
                                                    } ${
                                                        productOptions.embroiderySubmitted
                                                            ? 'disabled cursor-not-allowed opacity-50'
                                                            : null
                                                    }`}
                                                    aria-label={
                                                        verified
                                                            ? `${
                                                                  productOptions.embroiderySubmitted
                                                                      ? 'Embroidery options have been submitted. Please add your item to your cart.'
                                                                      : 'Save embroidery options without adding to cart.'
                                                              }`
                                                            : 'Please select all required options.'
                                                    }
                                                    data-balloon-pos="up"
                                                    data-balloon-length="fit"
                                                    data-option="embroiderySubmitted"
                                                    onMouseOver={(e) => {
                                                        if (!verified) {
                                                            handleOptions(e, {
                                                                error: true,
                                                            })
                                                        }
                                                    }}
                                                    onClick={
                                                        verified
                                                            ? (e) => {
                                                                  handleOptions(
                                                                      e,
                                                                      {
                                                                          verified: true,
                                                                      }
                                                                  )
                                                                  closeModal(e)
                                                              }
                                                            : null
                                                    }
                                                >
                                                    {saving
                                                        ? 'Saving Options...'
                                                        : 'Save Options'}
                                                </button>
                                            </div>
                                            <div className="close-button mt-6 mb-3">
                                                <button
                                                    className="text-flint underline hover:text-ash"
                                                    onClick={closeModal}
                                                >
                                                    Close Window
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="embroidery-preview w-full lg:w-1/2 flex-1 mt-0 mb-4 lg:mb-0">
                                        <h3 className="option-heading text-xl mb-4">
                                            Embroidery Preview
                                        </h3>
                                        <div
                                            className={`embroidery-preview-content-wrap p-4 w-full min-h-[200px] ${
                                                currentBgColorClass
                                                    ? currentBgColorClass
                                                    : ''
                                            } ${
                                                currentFontClass
                                                    ? currentFontClass
                                                    : ''
                                            }`}
                                        >
                                            {productOptions.embroideryText &&
                                            productOptions.embroideryText !==
                                                '' ? (
                                                <div
                                                    className={`embroidery-preview-content text-[28px] break-all font-normal ${
                                                        currentTextColorClass
                                                            ? currentTextColorClass
                                                            : ''
                                                    }`}
                                                >
                                                    {productOptions
                                                        .embroideryFont
                                                        ?.webName ===
                                                    'Monogram' ? (
                                                        <span
                                                            id="monogram-preview"
                                                            className="monogram-preview uppercase"
                                                        >
                                                            {parse(
                                                                monogramText
                                                            )}
                                                        </span>
                                                    ) : (
                                                        productOptions.embroideryText
                                                    )}
                                                </div>
                                            ) : null}
                                            {productOptions.embroideryText2 &&
                                            productOptions.embroideryText2 !==
                                                '' ? (
                                                <div
                                                    className={`embroidery-preview-content embroidery-preview-date text-[28px] font-normal ${
                                                        currentTextColorClass
                                                            ? currentTextColorClass
                                                            : ''
                                                    }`}
                                                >
                                                    {
                                                        productOptions.embroideryText2
                                                    }
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default Embroidery
